<div
  class="relative cursor-pointer p-[12px] rounded transition-colors duration-200 m-0.5  group"
  [ngClass]="{
    'bg-secondary-100 ': isOptionSelected(option),
    'hover:bg-secondary-100/60': !isOptionSelected(option),
    'bg-white border-transparent': !isOptionSelected(option)
  }"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
  (mouseenter)="highlighted = true"
  (mouseleave)="highlighted = false"
  (mousedown)="onOptionMouseDown($event)"
  (click)="onOptionClick($event)"
  (keydown.enter)="onOptionClick($event)"
>
  <div class="flex items-center gap-2 w-full">
    <!-- Checkbox for multi-select -->
    <div *ngIf="multiple" 
         class="w-4 h-4 border-2 border-option-default rounded flex-shrink-0 flex items-center justify-center transition-colors duration-200"
         [class.border-primary-500]="isOptionSelected(option)"
         [class.bg-primary-500]="isOptionSelected(option)"
         [class.border-option-default]="!isOptionSelected(option)"
         [class.bg-option-checkbox-bg]="!isOptionSelected(option)">
      <div *ngIf="isOptionSelected(option)" class="w-full h-full bg-primary-500 border-primary-500 rounded flex items-center justify-center">
        <NiFormIcon *ngIf="checkIcon" [icon]="checkIcon" class="w-3 h-3 text-white"></NiFormIcon>
      </div>
    </div>
    
    
    <!-- Leading Icon/Profile Image -->
    <div *ngIf="option['profileImage'] || option['icon']" class="flex-shrink-0 flex items-center">
      <!-- Profile Image with Fallback -->
      <div *ngIf="option['profileImage']" 
           class="w-8 h-8 rounded-full border-2 overflow-hidden flex items-center justify-center"
           [class.border-primary-500]="isOptionSelected(option)"
           [class.border-option-default]="!isOptionSelected(option)">
        <img [src]="option['profileImage']" 
             [alt]="getOptionLabel(option)"
             class="w-full h-full object-cover"
             (error)="onImageError($event, option, 'profileImage')"
             [style.display]="option['imageLoaded'] !== false ? 'block' : 'none'">
        <div *ngIf="!option['imageLoaded']" 
             class="w-full h-full flex items-center justify-center text-white font-medium text-sm"
             [class.bg-primary-500]="isOptionSelected(option)"
             [class.bg-option-fallback]="!isOptionSelected(option)">
          {{ getFirstLetter(option) }}
        </div>
      </div>
      <!-- Icon -->
      <NiFormIcon *ngIf="!option['profileImage'] && (option['icon'] !== undefined)" 
             [icon]="option['icon']" 
             class="w-5 h-5 flex-shrink-0"
             [class.text-primary-500]="isOptionSelected(option)"
             [class.text-option-icon]="!isOptionSelected(option)"></NiFormIcon>
    </div>
    
    <div class="flex-1 min-w-0 flex flex-col gap-0.5">
      <div class="leading-tight lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-archivo whitespace-nowrap overflow-hidden text-ellipsis" 
           [class.text-black]="isOptionSelected(option)"
           [class.font-medium]="isOptionSelected(option)"
           [class.text-option-text]="!isOptionSelected(option)"
           [class.font-normal]="!isOptionSelected(option)">
        <ng-container *ngIf="splitDistanceLabel(getOptionLabel(option)) as parts; else plainOptionLabel">
          <span>{{ parts.name }}</span><span [style.color]="distanceMilesColor">{{ parts.miles }}</span>
        </ng-container>
        <ng-template #plainOptionLabel>{{ getOptionLabel(option) }}</ng-template>
      </div>
      <!-- Subtext/Subtitle -->
      <div *ngIf="option['subtext']" class="text-option-subtext text-xs">
        {{ option['subtext'] }}
      </div>
      <div *ngIf="option.code" class="text-xs leading-tight whitespace-nowrap overflow-hidden text-ellipsis"
           [class.text-option-subtext]="!isOptionSelected(option)"
           [class.font-normal]="!isOptionSelected(option)"
           [class.text-black]="isOptionSelected(option)">{{ option.code }}</div>
    </div>
    
    <!-- Badge Count -->
    <div *ngIf="showBadge && option['badgeCount'] && option['badgeCount'] > 0" 
         class="bg-option-badge text-option-badge-text text-xs rounded-full flex items-center justify-center min-w-5 h-5 px-1.5 ml-2">
      {{ option['badgeCount'] }}
    </div>
    
    <!-- Trailing Badge -->
    <div *ngIf="option['badge']" class="bg-option-badge text-option-badge-text text-xs rounded-full flex items-center justify-center min-w-5 h-5 px-1.5 ml-2">
      {{ option['badge'] }}
    </div>
    <!-- Trailing Shortcut -->
    <div *ngIf="option['shortcut']" class="text-option-shortcut text-xs ml-2">
      {{ option['shortcut'] }}
    </div>
    
    <!-- Favorite Star Toggle -->
    <div *ngIf="showFavoriteToggle" 
         class="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded transition-colors duration-200 hover:bg-option-favorite-hover cursor-pointer"
         (click)="onFavoriteToggle($event)"
         (keydown.enter)="onFavoriteToggle($event)">
      <NiFormIcon *ngIf="option['isFavorite'] !== undefined" [icon]="option['isFavorite'] ? 'star_filled' : 'star_outline'" 
             class="w-4 h-4 transition-colors duration-200"
             [class.text-option-favorite-active]="option['isFavorite']"
             [class.text-option-favorite-inactive]="!option['isFavorite']"></NiFormIcon>
    </div>
    
    <!-- Trailing Icon/Profile Image -->
    <div *ngIf="option['trailingProfileImage'] || option['trailingIcon']" class="flex-shrink-0 flex items-center">
      <!-- Trailing Profile Image with Fallback -->
      <div *ngIf="option['trailingProfileImage']" 
           class="w-6 h-6 rounded-full border-2 overflow-hidden flex items-center justify-center"
           [class.border-primary-500]="isOptionSelected(option)"
           [class.border-option-default]="!isOptionSelected(option)">
        <img [src]="option['trailingProfileImage']" 
             [alt]="getOptionLabel(option) + ' trailing'"
             class="w-full h-full object-cover"
             (error)="onImageError($event, option, 'trailingProfileImage')"
             [style.display]="option['trailingImageLoaded'] !== false ? 'block' : 'none'">
        <div *ngIf="!option['trailingImageLoaded']" 
             class="w-full h-full flex items-center justify-center text-white font-medium text-xs"
             [class.bg-primary-500]="isOptionSelected(option)"
             [class.bg-option-fallback]="!isOptionSelected(option)">
          {{ getFirstLetter(option) }}
        </div>
      </div>
      <!-- Trailing Icon -->
      <NiFormIcon *ngIf="!option['trailingProfileImage'] && (option['trailingIcon'] || 'arrow_right_rounded')" 
             [icon]="option['trailingIcon'] || 'arrow_right_rounded'" 
             class="w-4 h-4 flex-shrink-0"
             [class.text-primary-500]="isOptionSelected(option)"
             [class.text-option-icon]="!isOptionSelected(option)"></NiFormIcon>
    </div>
  </div>
</div> 